import { useEffect } from "react";
import { CoalitionStampsProgressDetail } from "../CoalitionStampsProgress";
import { SingleProductImg } from "../CoalitionComplements";
import {
  ExpiracyDetail,
  RedeemableLabel,
  privGtmKey,
  extractDataForKey,
  deleteData,
} from "../../utils";
import { not_available_horizontal, gift_icon } from "../../pngs";
import { CoalitionCollapsible } from "../CoalitionCollapsible";
import {
  sendTag,
  event_properties_102_03,
  event_properties_102_04,
} from "../CoalitionGtm";
import "./../CoalitionCards/CardDetail.scss";

export const CoalitionCardStampsDetail = ({ card }) => {
  const {
    id,
    available_to_redeem,
    required_balance,
    balance,
    image,
    title,
    description,
    terms_and_conditions,
    valid_until,
  } = card;
  const redeemable = balance >= required_balance || available_to_redeem >= 1;
  const balanceFixed = redeemable
    ? available_to_redeem * required_balance + balance
    : balance;
  const label = `Juntaste ${balanceFixed} de ${required_balance} sellos`;
  const labelToRedeem = extractDataForKey(
    description,
    "completed",
    "¡Ya puedes cambiar tus sellos!"
  );
  const desc = deleteData(description).trim()
    ? deleteData(description).trim()
    : `Compra ${required_balance} y llévate uno de regalo`;

  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) {
      let payload = event_properties_102_03();
      payload.punch_card_id = id;
      payload.punch_card_progress = label;
      sendTag(gtm, payload);
    }
  }, [gtm, id, label]);
  const sendEvent = () => {
    let payload = event_properties_102_04();
    payload.punch_card_id = id;
    payload.punch_card_progress = label;
    sendTag(gtm, payload);
  };

  return (
    <div className="card-detail">
      <div className="product-image">
        <SingleProductImg load={image} error={not_available_horizontal} />
      </div>
      <RedeemableLabel
        redeemable={redeemable}
        image={gift_icon}
        label={labelToRedeem}
      />
      <div className="title">{title}</div>
      <div className="description">{desc}</div>
      <ExpiracyDetail expiracy={valid_until} />
      <div className="progress-summary">
        <CoalitionStampsProgressDetail
          used={balanceFixed}
          needed={required_balance}
        />
        <div>{label}</div>
      </div>
      <div
        onClick={() => sendEvent()}
        onKeyPress={() => sendEvent()}
        role="button"
        tabIndex={0}
      >
        <CoalitionCollapsible terms={terms_and_conditions} />
      </div>
    </div>
  );
};
